'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _api = require('@react-google-maps/api');

var _utils = require('@appbaseio/reactivesearch/lib/utils');

var _types = require('@appbaseio/reactivecore/lib/utils/types');

var _types2 = _interopRequireDefault(_types);

var _misc = require('@appbaseio/reactivecore/lib/actions/misc');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScriptLoader = function ScriptLoader(props) {
	var children = props.children,
	    mapLibraries = props.mapLibraries,
	    mapKey = props.mapKey,
	    setMapScriptLoadError = props.setMapScriptLoadError,
	    setMapScriptLoaded = props.setMapScriptLoaded,
	    setMapScriptLoading = props.setMapScriptLoading,
	    mapScriptLoadStatus = props.mapScriptLoadStatus;

	(0, _react.useEffect)(function () {
		if (mapScriptLoadStatus.error) {
			console.error('Error loading google api: ', mapScriptLoadStatus.error);
		}
	}, [mapScriptLoadStatus.error]);

	if (typeof window === 'undefined') {
		return null;
	}

	if (!window.google && window.GOOGLE_SCRIPT_LOCK_ACQUIRED === true && !mapScriptLoadStatus.loaded) {
		return 'Initializing...';
	}

	if (!window.google && typeof window.GOOGLE_SCRIPT_LOCK_ACQUIRED === 'undefined') {
		window.GOOGLE_SCRIPT_LOCK_ACQUIRED = true;
		setMapScriptLoading(true);
	}
	if (window.google) {
		return children;
	}

	return _react2.default.createElement(
		_api.LoadScript,
		{
			onError: function onError(error) {
				setMapScriptLoadError(error);
				window.GOOGLE_SCRIPT_LOCK_ACQUIRED = false;
			},
			googleMapsApiKey: mapKey || '',
			libraries: Array.from(new Set(mapLibraries)) // avoid duplicates
			, onLoad: function onLoad() {
				if (mapScriptLoadStatus.loaded === false) {
					window.GOOGLE_SCRIPT_LOCK_ACQUIRED = false;
					setMapScriptLoaded(true);
				}
			}
		},
		children
	);
};

ScriptLoader.propTypes = {
	children: _types2.default.children,
	setMapScriptLoading: _types2.default.func,
	setMapScriptLoaded: _types2.default.func,
	setMapScriptLoadError: _types2.default.func,
	mapScriptLoadStatus: _types2.default.props,
	mapKey: _types2.default.string,
	mapLibraries: _types2.default.stringArray
};

ScriptLoader.defaultProps = {
	mapScriptLoadStatus: {},
	mapLibraries: []
};
var mapStateToProps = function mapStateToProps(state) {
	return {
		mapKey: state.config.mapKey,
		mapLibraries: state.config.mapLibraries,
		mapScriptLoadStatus: state.googleMapScriptStatus
	};
};

var mapDispatchtoProps = function mapDispatchtoProps(dispatch) {
	return {
		setMapScriptLoading: function setMapScriptLoading(loading) {
			return dispatch((0, _misc.setGoogleMapScriptLoading)(loading));
		},
		setMapScriptLoaded: function setMapScriptLoaded(loaded) {
			return dispatch((0, _misc.setGoogleMapScriptLoaded)(loaded));
		},
		setMapScriptLoadError: function setMapScriptLoadError(error) {
			return dispatch((0, _misc.setGoogleMapScriptError)(error));
		}
	};
};

exports.default = (0, _utils.connect)(mapStateToProps, mapDispatchtoProps)(ScriptLoader);